"use client";

import React from "react";

import ChatView from "@/components/ai/chat/chat-view";
import { ChatLayoutUrlSync } from "@/components/chat/chat-layout-url-sync";
import { useChatSwitch } from "@/hooks/use-chat-switch";

const GlobalViewManager = React.memo<{ children: React.ReactNode }>(
  ({ children }) => {
    const { selectedView } = useChatSwitch();

    return (
      <>
        <ChatLayoutUrlSync />
        <ChatView selectedView={selectedView}>{children}</ChatView>
      </>
    );
  },
);

GlobalViewManager.displayName = "GlobalViewManager";

export default GlobalViewManager;
